import script from "./DocumentNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentNumber.vue?vue&type=script&setup=true&lang=js"

import "./DocumentNumber.vue?vue&type=style&index=0&id=28bbedbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bbedbb"]])

export default __exports__